import { STOCK_CLIP } from '@/constants';

import { AssetsContainer } from '../Event/Asset/AssetsContainer';

export const StockLibrary = () => {
  return (
    <AssetsContainer
      assetType={STOCK_CLIP}
      isPublic={true}
      sortingField='StockClipName'
      className='mb-4 px-2 md:px-0'
    />
  );
};
